import { apiClient } from "@/lib/api-client"
import { HttpStatusCodes } from "@/lib/http-status-codes"
import {
    UserProfileDto,
    UpdateProfileRequest,
    OrganizationProfileDto,
} from "../dtos/userProfile"

const normalizePhone = (phone: string) => phone ? `+27${phone.replace(/^\+?27/, "").replace(/^0/, "")}` : ""

export const getUserProfile = async (): Promise<UserProfileDto> => {
    const response = await apiClient.get<UserProfileDto>("/Auth/Profile")
    if (!response.status || response.status !== HttpStatusCodes.OK) {
        throw new Error("Failed to fetch user profile")
    }
    return response.data
}

export const updateUserProfile = async (
    data: UpdateProfileRequest,
): Promise<UserProfileDto> => {
    data.phoneNumber = normalizePhone(data.phoneNumber);
    const response = await apiClient.put<UserProfileDto>("/Auth/Profile", data)
    if (!response.status || response.status !== HttpStatusCodes.OK) {
        throw new Error("Failed to update user profile")
    }
    return response.data
}

export const getOrganizationProfile = async (
    organizationId: string,
): Promise<OrganizationProfileDto> => {
    const response = await apiClient.get<
        OrganizationProfileDto | OrganizationProfileDto[]
    >(`/organizations/${organizationId}/profile`)
    if (!response.status || response.status !== HttpStatusCodes.OK) {
        throw new Error("Failed to fetch organisation profile")
    }
    const data = response.data
    return Array.isArray(data) ? data[0] : data
}

export const uploadWelcomeVideo = async (
    organizationId: string,
    videoFile: File,
): Promise<string> => {
    const formData = new FormData()
    formData.append("video", videoFile)

    const response = await apiClient.post<{ blobUrl: string }>(
        `/organizations/${organizationId}/welcome-video`,
        formData,
        {
            headers: { "Content-Type": "multipart/form-data" },
        },
    )
    if (!response.status || response.status !== HttpStatusCodes.OK) {
        throw new Error("Failed to upload welcome video")
    }
    return response.data.blobUrl
}

export const deleteWelcomeVideo = async (
    organizationId: string,
): Promise<boolean> => {
    const response = await apiClient.delete<boolean>(
        `/organizations/${organizationId}/welcome-video`,
    )
    if (!response.status || ![200, 204].includes(response.status)) {
        throw new Error("Failed to delete welcome video")
    }
    return response.data || true
}
